export default class FormValidationErrors
{
    constructor(component, errors = [], alertFor = []) {
        this.component = component;
        this.alertFor = alertFor;
        this.fill(errors);
    }

    setComponent(component) {
        this.component = component;

        return this;
    }

    has(handle) {
        return this.errors && typeof this.errors[handle] === 'object';
    }

    get(handle) {
        return this.has(handle) ? this.errors[handle] : {};
    }

    first(handle) {
        return this.errors[handle][0];
    }

    fill(errors) {
        this.errors = errors;

        this.processAlerts();

        return this;
    }

    all() {
        return this.errors;
    }

    reset() {
        this.errors = {};
    }

    handleResponse(data) {
        this.fill(data).transitionToFirst();
    }

    processAlerts() {
        let message = "Whoops! There were problems:\r\n\r\n";
        let alertCount = 0;
        for (let i in this.errors) {
            if (this.alertFor.indexOf(i) > -1) {
                message += this.errors[i].join("\r\n");
                alertCount++;
            }
        }

        if (alertCount > 0) {
            alert(message);
        }
    }

    transitionToFirst() {

        let tries = 0;

        let waitForErrors = function() {
            if (tries >= 10) { return; }
            let element = this.component.$el.querySelector('.has-warning');

            if (!element) {
                tries++;
                setTimeout(waitForErrors.bind(this), 100);
            } else {

                /*$(this.component.$children[0].$el).find('> div').animate({
                    scrollTop: element.getBoundingClientRect().top - 100
                }, 1000, function() {
                    
                });*/

                window.scroll({ top: element.getBoundingClientRect().top - 100, left: 0, behavior: 'smooth' });

                element.querySelector('select, input').focus();
            }
        };

        setTimeout(waitForErrors.bind(this), 100);

        return this;
    }
}